import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import { useLocation } from 'react-router-dom';
// import Button from '../../components/Button/Button';
// import LiquidGlassCard from '../../components/LiquidGlassCard/LiquidGlassCard';
import './Checkout.css';

const Checkout = () => {
  const navigate = useNavigate();

  // For now, redirect to crypto payment — only crypto is available
  useEffect(() => {
    navigate('/crypto-payment', { replace: true });
  }, [navigate]);

  return null;

  // --- Commented out: card & product selection (to be restored later) ---
  // const location = useLocation();
  // const { service, country, price } = location.state || { service: 'WhatsApp', country: 'United States', price: 0.50 };
  // const [paymentMethod, setPaymentMethod] = useState('card');
  // const [selectedProduct, setSelectedProduct] = useState('private');
  //
  // return (
  //   <div className="checkout-page">
  //     <div className="container">
  //       <div className="checkout-header">
  //         <h1 className="page-title">Secure Checkout</h1>
  //         <p className="page-subtitle">Complete your purchase by selecting a product and payment method below.</p>
  //       </div>
  //
  //       <div className="checkout-grid">
  //         <div className="checkout-main">
  //           {/* Product Selection */}
  //           <LiquidGlassCard>
  //             <h2 className="section-title">1. Choose Your Product</h2>
  //             <div className="product-options">
  //               <label className={`product-option ${selectedProduct === 'private' ? 'active' : ''}`}>
  //                 <input
  //                   type="radio"
  //                   name="product"
  //                   value="private"
  //                   checked={selectedProduct === 'private'}
  //                   onChange={(e) => setSelectedProduct(e.target.value)}
  //                 />
  //                 <div className="product-info">
  //                   <p className="product-title">Get a Private Number</p>
  //                   <p className="product-price">$5.99 per week</p>
  //                 </div>
  //               </label>
  //               <label className={`product-option ${selectedProduct === 'credits' ? 'active' : ''}`}>
  //                 <input
  //                   type="radio"
  //                   name="product"
  //                   value="credits"
  //                   checked={selectedProduct === 'credits'}
  //                   onChange={(e) => setSelectedProduct(e.target.value)}
  //                 />
  //                 <div className="product-info">
  //                   <p className="product-title">Buy More Credits</p>
  //                   <p className="product-price">100 Credits for $10.00</p>
  //                 </div>
  //               </label>
  //             </div>
  //           </LiquidGlassCard>
  //
  //           {/* Payment Method */}
  //           <LiquidGlassCard>
  //             <h2 className="section-title">2. Select Payment Method</h2>
  //             <div className="payment-tabs">
  //               <button
  //                 className={`payment-tab ${paymentMethod === 'card' ? 'active' : ''}`}
  //                 onClick={() => setPaymentMethod('card')}
  //               >
  //                 Credit / Debit Card
  //               </button>
  //               <button
  //                 className={`payment-tab ${paymentMethod === 'crypto' ? 'active' : ''}`}
  //                 onClick={() => navigate('/crypto-payment')}
  //               >
  //                 Cryptocurrency
  //               </button>
  //             </div>
  //
  //             {paymentMethod === 'card' && (
  //               <form className="payment-form">
  //                 <div className="form-group">
  //                   <label className="form-label">Card Number</label>
  //                   <div className="input-with-icon">
  //                     <input type="text" className="form-input" placeholder="0000 0000 0000 0000" />
  //                     <span className="material-symbols-outlined input-icon">credit_card</span>
  //                   </div>
  //                 </div>
  //                 <div className="form-row">
  //                   <div className="form-group">
  //                     <label className="form-label">Expiration Date</label>
  //                     <input type="text" className="form-input" placeholder="MM / YY" />
  //                   </div>
  //                   <div className="form-group">
  //                     <label className="form-label">CVC</label>
  //                     <input type="text" className="form-input" placeholder="123" />
  //                   </div>
  //                 </div>
  //                 <div className="form-group">
  //                   <label className="form-label">Name on Card</label>
  //                   <input type="text" className="form-input" placeholder="John Doe" />
  //                 </div>
  //               </form>
  //             )}
  //           </LiquidGlassCard>
  //         </div>
  //
  //         {/* Order Summary */}
  //         <aside className="checkout-sidebar">
  //           <LiquidGlassCard className="summary-card">
  //             <h3 className="summary-title">Order Summary</h3>
  //             <div className="summary-items">
  //               <div className="summary-item">
  //                 <span>Private Number (1 week)</span>
  //                 <span>$5.99</span>
  //               </div>
  //               <div className="summary-item">
  //                 <span>Subtotal</span>
  //                 <span>$5.99</span>
  //               </div>
  //             </div>
  //             <div className="summary-divider"></div>
  //             <div className="summary-total">
  //               <span>Total Due</span>
  //               <span>$5.99</span>
  //             </div>
  //             <Button variant="primary" fullWidth size="large">
  //               Pay $5.99
  //             </Button>
  //             <div className="secure-notice">
  //               <span className="material-symbols-outlined">lock</span>
  //               <span>SSL Secured Payment</span>
  //             </div>
  //           </LiquidGlassCard>
  //         </aside>
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default Checkout;
